import { IPost } from '@sdk/contracts';
import { dateProvider } from '@utils';
import { useTranslation } from 'react-i18next';

import { usePostViewer } from '../../../../hooks';

import {
  DateWrapper,
  FeaturedTag,
  BottomWrapper,
  InfoWrapper,
  PostWrapper,
  StyledImage,
  TitleWrapper
} from './PostItem.styles';

type Props = {
  post: IPost;
  isFeatured?: boolean;
};

export const PostItem: React.FC<Props> = ({ post, isFeatured }) => {
  const { t } = useTranslation('StudentDashboardTranslations');
  const { setPostId } = usePostViewer();

  const { _id, title, createdAt, featuredImage, topic, scheduledPublishDate } = post;

  const handleOpenPost = () => {
    setPostId(_id);
  };

  return (
    <PostWrapper onClick={handleOpenPost} $isFeatured={isFeatured}>
      {isFeatured && <FeaturedTag>{t('FEATURED_NEWS')}</FeaturedTag>}
      {featuredImage && <StyledImage src={featuredImage?.url} alt="News preview" />}
      <InfoWrapper>
        <TitleWrapper>{title}</TitleWrapper>
        <BottomWrapper>
          <DateWrapper>
            <div>
              {scheduledPublishDate
                ? dateProvider.format(
                    dateProvider.zonedTimeToUtc(scheduledPublishDate),
                    'dd MMM, yyyy'
                  )
                : dateProvider.format(createdAt, 'dd MMM, yyyy')}
            </div>
          </DateWrapper>
          <span>·</span>
          <div>{topic?.name}</div>
        </BottomWrapper>
      </InfoWrapper>
    </PostWrapper>
  );
};
